import React from 'react';
import { Box } from '@material-ui/core';
import { useCommonStyles } from '../useCommonStyles';
import { InfoCardSection } from '../components/InfoCardSection';
import { HelpContent } from '../components/HelpContent';

const DialogEtiquetaContent = ({ handleClose, handleSubmit, isAbbiamoStatusNotDone, disabled }) => {
    const classes = useCommonStyles();

    return (
        <Box className={classes.topContent}>
            <span className={classes.subtitle}>Apresente a etiqueta para o entregador e <strong>aguarde a validação</strong> para liberar o pedido.</span>
            <InfoCardSection title='Validação de leitura da etiqueta' isLoading={isAbbiamoStatusNotDone} />
            <InfoCardSection title='Pedido liberado para entrega' isLoading={isAbbiamoStatusNotDone} />
            <HelpContent helpText='Se houver problemas na validação ou na retirada do pacote, entre em contato com o SAL.' />
        </Box>
    );
};

export default DialogEtiquetaContent;